@let s = section();
<div [attr.id]="s.id">
  <cft-content-section titleAlignment="left" [title]="s.title" [plot]="s.plot">
    @if (s.source === 'otovo') {
      <bgo-iframe-otovo />
    }
  </cft-content-section>
</div>
